import { InjectionToken } from '@angular/core';

/**
 * PS-6495 — the browser window, injected rather than reached for.
 *
 * Injected for one thing since the login moved into the page: `location.hostname`, which
 * `InlineLoginService` turns into the brand the credentials are checked against. Reaching for the
 * global would make that untestable, and getting the brand wrong refuses every customer on the
 * host — so it is worth a token even at one call site.
 */
export const WINDOW = new InjectionToken<Window>('WINDOW', {
	providedIn: 'root',
	factory: () => window,
});
